import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import TabelDosenTetap from './TabelDosenTetap';

class DosenTetap extends Component {
    componentDidMount = () => {

    }
    render() {
        return (
            <div className="row" id="smoothMain">
                <div className="col-xl-12">
                    <div className="card card-custom">
                        <div className="card-body">

                            <div className="col-md-12 grid-margin">
                                <div className="row">
                                    <div className="col-12 col-xl-8 mb-1 mb-xl-0">
                                        <p className="card-title" style={{ fontSize: '23px' }}>Data Dosen Tetap</p>
                                    </div>
                                    <div className="col-12 col-xl-4">
                                        <div className="justify-content-end d-flex">
                                            <div className="dropdown flex-md-grow-1 flex-xl-grow-0">
                                                <button
                                                    className="btn btn-primary btn-sm btnOptCust dropdown-toggle"
                                                    type="button" id="dropdownMenuDate2" data-toggle="dropdown"
                                                    aria-haspopup="true" aria-expanded="true"
                                                >
                                                    dosen tetap
                                                </button>
                                                <div className="dropdown-menu dropdown-menu-right"
                                                    aria-labelledby="dropdownMenuDate2">
                                                    <Link className="dropdown-item"
                                                        to="/data-dosen/lb"
                                                    >
                                                        dosen luar biasa
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="table-responsive">
                                <TabelDosenTetap />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default DosenTetap;